import { createSlice } from '@reduxjs/toolkit';
export const appSlice = createSlice({
    name: 'appState',
    initialState: {
        estado:[]
    },
    reducers: {
        change_estado: (state, action) => {
            state.estado.push(action.payload);
        },
        clean_estado: (state, action) => {
            state.estado.splice(0);
        },
        
    }
});
export const { change_estado, clean_estado } = appSlice.actions;
export default appSlice.reducer;